var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_144_239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.134277,
    y: 0.418457,
    width: 17.5761,
    height: 17.5761,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_144_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0638 15.0652C2.66101 15.0652 2.3162 14.9218 2.02937 14.635C1.74254 14.3482 1.59912 14.0033 1.59912 13.6006V4.8125C1.59912 4.40971 1.74254 4.06491 2.02937 3.77807C2.3162 3.49124 2.66101 3.34782 3.0638 3.34782H7.45783L8.92251 4.8125H14.7812C15.184 4.8125 15.5288 4.95592 15.8156 5.24275C16.1025 5.52958 16.2459 5.87439 16.2459 6.27718H3.0638V13.6006L4.82141 7.74185H17.3444L15.4586 14.0217C15.361 14.339 15.1809 14.5923 14.9185 14.7815C14.6561 14.9706 14.3662 15.0652 14.0489 15.0652H3.0638Z",
    fill: "#6C6C6C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.0522480e4d6a35a59c3f5c52bc0aac75.svg";
export { ForwardRef as ReactComponent };